import Axios from "axios";
import {
  SET_SALE_INVOICE_LIST,
  UNSET_SALE_INVOICE_LIST,
  SET_SALE_PAYMENT_LIST,
  UNSET_SALE_PAYMENT_LIST,
  SET_SALE_STATEMENT_REPORTS,
  UNSET_SALE_STATEMENT_REPORTS,
} from "@/store/mutation-types";
import { saveUpdateSaleInvoice, saveUpdateSaleInvoiceTaxAdjustment, getSaleInvoiceList, getSaleInvoiceById, saveCustomerPayment, getCustomerPaymentList, getSalesStatementReports } from "@/store/api";
// initial state
const state = {
  getSaleInvoiceList: [],
  editingSaleInvoice: null,
  viewingSaleInvoice: null,
  getCustomerPaymentList: [],
  getSalesStatementReports: [],
};

const getters = {
  getSaleInvoiceList(state) {
    return state.getSaleInvoiceList;
  },
  getEditingSaleInvoice: (state) => state.editingSaleInvoice,
  getViewingSaleInvoice: (state) => state.viewingSaleInvoice,
  getCustomerPaymentList(state) {
    return state.getCustomerPaymentList;
  },
  getSalesStatementReports(state) {
    return state.getSalesStatementReports;
  },
};

const mutations = {
  [SET_SALE_INVOICE_LIST](state, data) {
    state.getSaleInvoiceList = data;
  },
  [UNSET_SALE_INVOICE_LIST](state) {
    state.getSaleInvoiceList = [];
  },
  [SET_SALE_PAYMENT_LIST](state, data) {
    state.getCustomerPaymentList = data;
  },
  [UNSET_SALE_PAYMENT_LIST](state) {
    state.getCustomerPaymentList = [];
  },
  [SET_SALE_STATEMENT_REPORTS](state, data) {
    state.getSalesStatementReports = data;
  },
  [UNSET_SALE_STATEMENT_REPORTS](state) {
    state.getSalesStatementReports = [];
  },
  setEditingSaleInvoice(state, lead) {
    state.editingSaleInvoice = lead;
  },
  setViewingSaleInvoice(state, lead) {
    state.viewingSaleInvoice = lead;
  },
};

const actions = {
  saveUpdateSaleInvoice({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSaleInvoice, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  saveUpdateSaleInvoiceTaxAdjustment({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSaleInvoiceTaxAdjustment, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSaleInvoiceList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSaleInvoiceList, data)
        .then(function (response) {
          commit("SET_SALE_INVOICE_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_SALE_INVOICE_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },

  // FIXED: The main problem was here
  getSaleInvoiceById({ commit }, data) {
    const getSaleInvoiceByIdApi = `${getSaleInvoiceById}/${data}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getSaleInvoiceByIdApi)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          commit("UNSET_SALE_INVOICE_LIST");
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  saveCustomerPayment({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });    
    return new Promise((resolve, reject) => {
      Axios.post(saveCustomerPayment, data)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      })
      .then((always) => {
        commit("UNSET_LOADING");
      });
    });
  },

  getCustomerPaymentList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getCustomerPaymentList, data)
        .then(function (response) {
          commit("SET_SALE_PAYMENT_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_SALE_PAYMENT_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },

  getSalesStatementReports({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSalesStatementReports, data)
        .then(function (response) {
          commit("SET_SALE_STATEMENT_REPORTS", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_SALE_STATEMENT_REPORTS");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
